import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';
import { selectors as rootSelectors } from '../root';

import Filters from '../shared/filters/main';
import Calendar from '../shared/calendar/main';
import Table from './components/table/main';
import ConversionsFrom from './components/form/conversions-filter';

import Select from '../shared/form-elements/select/select';

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content affiliates-redeem">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">{props.intl('Affiliates redeem')}</h1>
					</div>
				</div>
				<div className="container__content-body">
					<div className="affiliates-redeem__filter-position clearfix">
						<Filters {...props} {...props.filters} />
					</div>

					<div className="ui-control-bar">
						<div className="ui-control-bar__item modify-item---convertions">
							<div className="ui-control-bar__item-position">
								<ConversionsFrom {...props} initialValues={props.conversionsFilterInitialValues} />
							</div>
						</div>
						<div className="ui-control-bar__item modify-item---countries">
							<div className="ui-control-bar__item-position">
								<div className="form-element-select-improve">
									<Select
										value={props.locationFilterValues}
										options={props.locationsLookup}
										name="countries"
										placeholder="Select a country"
										onChange={props.applyLocation}
										multi={true}
									/>
								</div>
							</div>
						</div>
						<div className="ui-control-bar__item modify-item---calendar">
							<div className="ui-control-bar__item-position">
								<Calendar
									{...props.calendar}
									onInit={props.calendarInit}
									onToggle={props.calendarToggle}
									onChange={props.calendarChange}
									onApply={props.calendarApply}
									intl={props.intl}
								/>
							</div>
						</div>

						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								<button className="ui-btn ui-btn-primary apply" onClick={props.apply}>
									{props.intl('Apply')}
								</button>
								<button className="ui-btn ui-btn-secondary ui-icon-clear" onClick={props.clear} />
							</div>
						</div>
					</div>

					<div className="affiliates-redeem__table-position">
						<Table {...props} />
					</div>
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		table: selectors.getTable(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		calendar: selectors.getCalendar(state),
		filters: selectors.getFilters(state),
		currentDateRange: selectors.getCurrentDateRange(state),
		openedAffiliateIds: selectors.getOpenedAffiliateIds(state),
		conversionsFilterInitialValues: selectors.getConversionsFilterInitialValues(state),
		locationFilterValues: selectors.getLocationFilterValues(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		progressBar: selectors.getProgressBar(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates-redeem/main.js